import { Box, Typography, alpha, useTheme } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { brand, brandNavItems } from '../config'

const resolveBoardAccent = (theme, boardId) => {
  const colors = theme.custom?.colors || {}
  const keysys = theme.custom?.keysys || {}
  switch (boardId) {
    case 'vulnerabilities':
      return colors.supportTypes?.vulnerability || '#f33b59'
    case 'upgrades':
      return colors.supportTypes?.upgrade || '#ffd54f'
    case 'clientOrganization':
      return colors.billingDrawer?.accent || '#F57C00'
    case 'dashboard':
    default:
      return keysys.blue || '#64b5f6'
  }
}

const resolveActiveBoard = (pathname) => {
  const match = brandNavItems.find((board) => {
    if (!board?.path) return false
    if (board.path === '/') return pathname === '/' || pathname === ''
    return pathname === board.path || pathname.startsWith(`${board.path}/`)
  })
  return match || brand.boards.dashboard
}

/**
 * Color-coded strip showing which SOCR board is active
 * (Dashboard / Vulnerabilities / Upgrades / Client Organization).
 */
const SocrBoardStatusBar = ({ trailing = null, dense = false }) => {
  const theme = useTheme()
  const { pathname } = useLocation()
  const board = resolveActiveBoard(pathname)
  const accent = resolveBoardAccent(theme, board.id)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        borderTop: `1px solid ${alpha(accent, 0.35)}`,
        px: { xs: 0.75, sm: 1, md: 1.25 },
        py: dense ? 0.45 : 0.55,
        background: `linear-gradient(90deg, ${alpha(accent, 0.22)} 0%, ${alpha(accent, 0.08)} 42%, ${alpha('#000', 0.18)} 100%)`,
        boxShadow: `inset 3px 0 0 ${accent}`
      }}
    >
      <Typography
        component='div'
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          flexWrap: 'wrap',
          columnGap: 0.75,
          rowGap: 0.15,
          minWidth: 0,
          lineHeight: 1.2
        }}
      >
        <Typography
          component='span'
          sx={{
            fontWeight: 700,
            fontSize: '0.68rem',
            letterSpacing: 0.55,
            textTransform: 'uppercase',
            color: alpha('#fff', 0.5)
          }}
        >
          Board
        </Typography>
        <Typography
          component='span'
          sx={{
            fontWeight: 800,
            fontSize: '0.84rem',
            color: alpha('#fff', 0.96),
            letterSpacing: 0.1
          }}
          noWrap
        >
          {board.label}
        </Typography>
      </Typography>

      {trailing
        ? (
          <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            {trailing}
          </Box>
          )
        : (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: accent,
              boxShadow: `0 0 0 3px ${alpha(accent, 0.25)}`,
              flexShrink: 0
            }}
          />
          )}
    </Box>
  )
}

export { SocrBoardStatusBar, resolveActiveBoard, resolveBoardAccent }
